import {
    HttpResponse,
    StateOfCapitalYearModel,
    QueryModel,
    RequestParams,
    StateOfCapitalYearModelIEnumerableApiResultSuccess,
    StateOfCapitalYearModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class StateOfCapitalYearDataService implements CrudService<StateOfCapitalYearModel, StateOfCapitalYearModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<StateOfCapitalYearModel>): Promise<CrudListResponse<StateOfCapitalYearModel>> {
        return ApiService.api.getStateOfCapitalYearBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<StateOfCapitalYearModel>> {
        return ApiService.api.getStateOfCapitalYearById(id, params);
    }

    create(item: StateOfCapitalYearModel, params?: RequestParams): Promise<CrudResponse<StateOfCapitalYearModel>> {
        return ApiService.api.insertStateOfCapitalYear(item, params);
    }

    update(item: StateOfCapitalYearModel, params?: RequestParams): Promise<StateOfCapitalYearModel> {
        return ApiService.api.updateStateOfCapitalYear(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<StateOfCapitalYearModel> {
        return ApiService.api.patchStateOfCapitalYear(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<StateOfCapitalYearModel>): Promise<CrudListResponse<StateOfCapitalYearModel>> {
        return ApiService.api.deleteStateOfCapitalYear(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<StateOfCapitalYearModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
